import React from 'react';
import SyncButton from '../components/SyncButton';

export default function ReviewsActionsBar({ onSync, syncing, lastSyncAt }) {
  return (
    <div style={styles.bar}>
      <SyncButton onSync={onSync} syncing={syncing} lastSyncAt={lastSyncAt} />
    </div>
  );
}

const styles = {
  bar: {
    padding: '4px 16px 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
};
